export const config = {
  appLanguage: "en",
};
